import { SELECT_DROPDOWN_ROLE } from '../../../../../constants/select'

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_EDIT_DROPDOWN_SELECTOR = `[role="${SELECT_DROPDOWN_ROLE}"]`

export const ENTITY_PROFILE_HEADER_INFO_ITEM_DEADLINE_EDIT_INVALID_ERROR_KEY =
  'RequestProfile.HeaderDeadlineInvalidDateErrorKey'

export const EntityProfileHeaderInfoItemDeadlineEditState = {
  Editing: 'editing',
  Saving: 'saving',
  View: 'view',
}
